import React from 'react';
import tw from 'twin.macro';

export const Pill = ({ label, success, warning, danger, info, ...restProps }) => {
  const labelValue = label ? label.toLowerCase() : undefined;
  return (
    <span
      css={[
        tw`bg-secondary inline-flex`,
        !label && tw`h-1.5 w-1.5 rounded-full`,
        label && tw`items-center py-1 px-2 rounded-lg text-xs font-medium text-light`,
        success && tw`bg-success text-dark`,
        warning && tw`bg-warning text-dark`,
        danger && tw`bg-danger text-dark`,
        info && tw`bg-info text-dark`,
      ]}
      {...restProps}
    >
      {labelValue}
    </span>
  );
};
